module.exports = __webpack_public_path__ + "static/img/icn_avatar.8e947d8.png";